import type { Locale } from "@i18n/react";

import type { BaseKeyFunction } from "../../../lib/types/baseKeyFunction";
import type { SearchItemType } from "./types/enums/searchItemTypeEnum.enums";

export type KeySearchProps = {
  filters: {
    locale: Locale;
    type?: SearchItemType;
  };
  search: string;
};

export const keySearch: BaseKeyFunction<KeySearchProps> = ({
  filters,
  search,
}) => ["search", filters, search];
